import { html, ref, repeat } from '@microsoft/fast-element';
import { sync } from '@genesislcap/foundation-utils';
import type { LocationTab } from './location-tab';

export const LocationTabTemplate = html<LocationTab>`
  <div class="form-control required">
    <label>Country</label>
    <zero-select
      ${ref('country')}
      id="country"
      :value=${sync((x) => x.countryValue)}
      class="input-control"
      @change="${(x) => x.countrySelected()}"
      disabled="true"
    >
      <zero-option value="">Select Country</zero-option>
      ${repeat(
        (x) => x._allCountries,
        html`
          <zero-option value="${(x) => x.COUNTRY_NAME}">${(x) => x.COUNTRY_NAME}</zero-option>
        `,
      )}
    </zero-select>
  </div>

  <div style="display: ${(x) => (x.countryValue === 'United States' ? '' : 'none')}">
    <div class="form-control required">
      <label>State</label>
      <zero-select
        :value=${sync((x) => x.stateValue)}
        class="input-control"
        :disabled="${(x) => x.projectModalService.modalMode === 'edit'}"
        ${ref('state')}
        @change="${(x) => x.stateSelected()}"
      >
        <zero-option value="">Select State</zero-option>
        ${repeat(
          (x) => x._allStates,
          html`
            <zero-option value="${(x) => JSON.stringify(x)}">${(x) => x.STATE_NAME}</zero-option>
          `,
        )}
      </zero-select>
    </div>

    <div class="form-control required short-dropdown">
      <label>County</label>
      <zero-select
        ${ref('county')}
        :value=${sync((x) => x.countyValue)}
        class="input-control"
        ?disabled="${(x) => !x.stateValue}"
      >
        <zero-option value="">Select County</zero-option>
        ${repeat(
          (x) => x._counties,
          html`
            <zero-option value="${(x) => x.COUNTY_NAME}">${(x) => x.COUNTY_NAME}</zero-option>
          `,
        )}
      </zero-select>
    </div>

    <div class="form-control">
      <label>City</label>
      <zero-select
        ${ref('city')}
        :value=${sync((x) => x.cityValue)}
        class="input-control"
        ?disabled="${(x) => !x.stateValue}"
      >
        <zero-option value="">Select City</zero-option>
        ${repeat(
          (x) => x._cities,
          html`
            <zero-option value="${(x) => x.CITY_NAME}">${(x) => x.CITY_NAME}</zero-option>
          `,
        )}
      </zero-select>
    </div>
  </div>

  <div class="form-control long-error">
    <zero-number-field
      ${ref('latitude')}
      :value=${sync((x) => x.latitudeValue)}
      class="input-control"
      min="-90"
      max="90"
      hide-step
      placeholder="Enter..."
      required
    >
      Latitude
    </zero-number-field>
  </div>

  <div class="form-control long-error">
    <zero-number-field
      ${ref('longitude')}
      :value=${sync((x) => x.longitudeValue)}
      class="input-control"
      min="-180"
      max="180"
      hide-step
      placeholder="Enter..."
      required
    >
      Longitude
    </zero-number-field>
  </div>
`;
